import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../models/calendar/actions';
import Calendar from '../components/Calendar/index';


const mapStateToProps = state => ({
    answer: state.calendar
});

const mapDispatchProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

const CalendarContainer = connect(
    mapStateToProps,
    mapDispatchProps
)(Calendar);

export default CalendarContainer;



// WEBPACK FOOTER //
// ./src/containers/Calendar.container.js